/**
 * Single source of truth for join funnel route paths. Step 1 lives at the
 * variant root; steps 2 and 3 are nested under it. The default variant has
 * no prefix.
 *
 *   /join                  → step 1, default variant
 *   /join/profile          → step 2, default variant
 *   /join/location         → step 3, default variant
 *
 *   /join/test-before-test           → step 1
 *   /join/test-before-test/profile   → step 2
 *   /join/test-before-test/location  → step 3
 *
 *   /join/checkup           → step 1
 *   /join/checkup/profile   → step 2
 *   /join/checkup/location  → step 3
 */

import type { PositioningVariant } from '@/constants/funnel';

export const ROUTE_JOIN_FUNNEL_BASE = '/join';

export type FunnelStepNumber = 1 | 2 | 3;

const STEP_SLUGS: Record<FunnelStepNumber, string> = {
  1: '',
  2: 'profile',
  3: 'location',
};

export function stepRoutePath(variant: PositioningVariant, step: FunnelStepNumber): string {
  const variantSegment = variant === 'default' ? '' : `/${variant}`;
  const stepSegment = STEP_SLUGS[step];
  if (!stepSegment) {
    return `${ROUTE_JOIN_FUNNEL_BASE}${variantSegment}` || '/';
  }
  return `${ROUTE_JOIN_FUNNEL_BASE}${variantSegment}/${stepSegment}`;
}
